import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { S } from './ProjectDialogs.styles';
import { useDeleteProject } from '../../../../../../../traits/api/projects/useDeleteProject';
import { ProjectRowTarget } from './ActionsCell';

type Props = {
  target: ProjectRowTarget | null;
  onClose: () => void;
};

export const DeleteProjectDialog: React.FC<Props> = ({ target, onClose }) => {
  const mutation = useDeleteProject();

  const handleConfirm = () => {
    if (!target) return;
    mutation.mutate(target.projectId);
    onClose();
  };

  return (
    <AlertDialog.Root open={!!target}>
      <AlertDialog.Portal>
        <S.Overlay>
          <S.Wrapper>
            <S.ContentContainer>
              <AlertDialog.Title asChild>
                <S.H5>Vill du verkligen ta bort projektet {target?.name}?</S.H5>
              </AlertDialog.Title>
            </S.ContentContainer>
            <S.ButtonContainer>
              <AlertDialog.Cancel asChild onClick={onClose}>
                <S.Button $outlined>Avbryt</S.Button>
              </AlertDialog.Cancel>
              <AlertDialog.Action asChild>
                <S.Button onClick={handleConfirm}>Bekräfta</S.Button>
              </AlertDialog.Action>
            </S.ButtonContainer>
          </S.Wrapper>
        </S.Overlay>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};
